import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../store/store";
import { getVerifyAuth } from "../store/thunk/authThunk";
import { useEffect } from "react";
import LoaderComponent from "../components/loader";
import { useAuth0 } from "@auth0/auth0-react";
import { setLoading } from "../store/slices/notificationSlice";
import queryString from "query-string";
import { logErrorFunction } from "../helper/service";

const LoginComponent = () => {
  const dispatch: any = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { loginWithRedirect, user, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const { authConfig } = useAppSelector((state: any) => state.authReducer);
  const { code } = queryString.parse(location.search);

  useEffect(() => {
    if (code && code === "startforfree") {
      navigate("/home");
    }
    if (code && code === "login") {
      loginWithRedirect();
    }
    if (code && code === "signup") {
      loginWithRedirect({
        authorizationParams: {
          screen_hint: "signUp",
        },
      });
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      const fetchToken = async () => {
        try {
          dispatch(setLoading(true));
          const token = await getAccessTokenSilently({
            authorizationParams: {
              redirect_uri: window.location.origin,
              scope: "openid profile email read:current_user",
            },
          });

          dispatch(setLoading(false));
          if (token) {
            localStorage.setItem("accessToken", token);
            localStorage.setItem("userData", JSON.stringify(user));
            localStorage.setItem("csrfToken", authConfig?.csrfToken);
            if (user?.email_verified) {
              dispatch(getVerifyAuth(token)).then((res: any) => {
                if (res.status === 200 && res?.payload?.data?.isVerified) {
                  navigate("/home");
                }
              });
            } else {
              navigate("/verify");
            }
          }

          // You can also make an authenticated API request here.
        } catch (e) {
          dispatch(setLoading(false));
          logErrorFunction("Error fetching access token:" + e);
        }
      };

      fetchToken();
    } else {
      if (!code) {
        loginWithRedirect();
      }
    }
  }, [isAuthenticated, getAccessTokenSilently]);

  return <LoaderComponent />;
};

export default LoginComponent;
